import { Box, Text, Flex, useTheme, HStack, Spacer } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useDisclosure } from "@chakra-ui/react";
import TeacherManagementTable from "../../../components/table/teacherManagement/TeacherManagementTable";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import SearchBox from "../../../components/searchbox/SearchBox";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import AddTeacherModal from "../../../components/modals/AddModals/AddTeacherModal";
import { getAllMentors } from "../../../store/slice/teacherManagementSlice";
import { useDispatch, useSelector } from "react-redux";

const TeacherOverview = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);
  const { teacherManagement, status } = useSelector(
    (state) => state.teacherManagement
  );

  useEffect(() => {
    dispatch(getAllMentors());
  }, []);

  const filteredTeacher = teacherManagement?.filter((teacher) =>
    teacher?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAddTeacher = () => {
    setEditData(null);
    onOpen();
  };
  return (
    <Box>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Teacher Management
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Teacher"} onClick={handleAddTeacher} />
      </Flex>

      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        {/* <SearchBox onSearch={setSearchTerm} /> */}
      </Flex>
      <TeacherManagementTable
        data={filteredTeacher}
        entityType="teacher"
        onEdit={(teacher) => {
          setEditData(teacher);
          onOpen();
        }}
        limit={limit}
      />

      <AddTeacherModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default TeacherOverview;
